export type ErrorDetails = {
  message: string;
  details?: string;
  errorCode?: number;
};

export function parseError(error: any): ErrorDetails {
  // check if body contains errors:
  let bodyErrors: any[] = [];
  if (error?.body?.errors) {
    bodyErrors = Array.isArray(error.body.errors)
      ? error.body.errors
      : [error.body.errors];
  }
  const bodyError = bodyErrors[0] || null;
  const res = {
    message: "error.unknown",
    details: bodyError?.detail || error.message,
    errorCode: bodyError?.code || error.status || 500,
  };

  // API errors with status codes
  switch (error.status) {
    case 401: {
      res.message = "error.unauthorized";
      break;
    }
    case 403: {
      res.message = "error.forbidden";
      break;
    }
    case 404: {
      res.message = "error.notFound";
      break;
    }
    case 503: {
      // Network/connection errors (like middleware not running, or backend not reachable)
      res.message = "error.network";
      break;
    }
    case 500: {
      // Network/connection errors (like middleware not running, or backend not reachable)
      res.message = "error.server";
      break;
    }
  }

  return res;
}
